<template>
  <div class="card" v-show="currentCardId == 'create-date'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>{{ heading }}</h2>
        <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <div class="create-date-action">
            <div class="action-item">
              <el-button
                class="button-block"
                :disabled="isTodaySelected"
                @click="setToday"
                >今日の日付を入力</el-button
              >
            </div>
            <div class="action-item">
              <el-button
                class="button-block"
                :disabled="isTomorrowSelected"
                @click="setTomorrow"
                >明日の日付を入力</el-button
              >
            </div>
            <div class="action-item">
              <el-date-picker
                v-model="formatData.createDate"
                type="date"
                :clearable="false"
                placeholder="選択してください"
                :format="'yyyy年M月d日'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'

withDefaults(
  defineProps<{
    currentCardId?: string
    heading?: string
  }>(),
  {
    heading: '職務経歴書の作成日を入力'
  }
)

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}

const { formLib: formLibRaw } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib
const formatData = useShokurekishoFormatData()

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  formatData.createDate = formLib.getToday()
}

function setTomorrow() {
  formatData.createDate = formLib.getTommorow()
}
</script>
